import { render, staticRenderFns } from "./InviteFriendsPage.vue?vue&type=template&id=7920567f&scoped=true&"
import script from "./InviteFriendsPage.vue?vue&type=script&lang=js&"
export * from "./InviteFriendsPage.vue?vue&type=script&lang=js&"
import style0 from "./InviteFriendsPage.vue?vue&type=style&index=0&id=7920567f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7920567f",
  null
  
)

export default component.exports